import { useState } from "react";
import { URLdecode } from "../../utils/url";
import TransactionsTabs from "./transactions/TransactionsTabs";
import TransactionsPayoutSection from "./transactions/TransactionsPayoutSection";
import TransactionTransactionsSection from "./transactions/TransactionTransactionsSection";
import TransactionsInvoiceSection from "./transactions/TransactionsInvoiceSection";

export default function TransactionsClone() {
  const params = URLdecode();
  const [tab, setTab] = useState(params?.tab);

  return (
    <div className="card py-10 px-10 flex flex-col gap-4 justify-center">
      <TransactionsTabs onTabChange={(tb) => setTab(tb)} />

      {(() => {
        switch (tab) {
          case "payout":
            return <TransactionsPayoutSection />;
          case "invoice":
            return <TransactionsInvoiceSection />;
          case "transaction":
          default:
            return <TransactionTransactionsSection />;
        }
      })()}
    </div>
  );
}
